import React, { useState, useEffect, useCallback  } from 'react';
import { useParams, useNavigate, } from 'react-router-dom';
import { db, auth } from '../../firebase';
import { setDoc, doc, serverTimestamp } from 'firebase/firestore';

const WritingTask1Write = () => {
  const { mockId } = useParams();
  const [essay, setEssay] = useState('');
  const [error, setError] = useState('');
  const [readingParagraphs, setReadingParagraphs] = useState([]);
  const [timeLeft, setTimeLeft] = useState(20 * 60); // 20 minutes in seconds
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const minWords = 100; 

useEffect(() => {
  const loadReading = async () => {
    try {
      const res = await fetch(`/data/${mockId}Writing1.json`);
      const data = await res.json();
      setReadingParagraphs(data.passage || []);
    } catch (err) {
      console.error('Error loading reading passage:', err);
    }
  };

  loadReading();
}, [mockId]);

const handleSubmit = useCallback(async () => {
  const wordCount = essay.trim().split(/\s+/).filter(Boolean).length;

  if (wordCount < minWords) {
    setError(`Your response must be at least ${minWords} words and between 150-225 words. Currently: ${wordCount} words.`);
    return;
  }

  const user = auth.currentUser;
  if (!user) {
    alert('You must be logged in.');
    return;
  }

  try {
    const answerRef = doc(db, 'users', user.uid, 'mockAnswers', 'mock1_writing1');
    await setDoc(answerRef, {
      essay: essay.trim(),
      createdAt: serverTimestamp(),
      email: user.email,
      name: user.displayName,
      role: 'student',
      mockId: 'mock1',
      task: 'writing1',
    });

    console.log('✅ Essay saved!');
    setSubmitted(true);
  } catch (err) {
    console.error('❌ Error saving essay:', err);
    alert('There was an error saving your essay. Please try again.');
  }
}, [essay, minWords]);
useEffect(() => {
  if (submitted) return;
  if (timeLeft <= 0) {
    handleSubmit();
    return;
  }

  const timer = setInterval(() => {
    setTimeLeft((prev) => prev - 1);
  }, 1000);

  return () => clearInterval(timer);
}, [timeLeft, submitted, handleSubmit]);



  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const wordCount = essay.trim().split(/\s+/).filter(Boolean).length;

  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6 text-darkblue-800 text-center">Writing Task 1 - Your Response</h1>

      <div className="bg-gray-100 p-4 rounded-md mb-6">
        <h2 className="text-lg font-semibold mb-4">Reading Passage</h2>
        {readingParagraphs.length > 0 ? (
          readingParagraphs.map((para, idx) => (
            <p key={idx} className="text-gray-700 mb-4 whitespace-pre-line">{para}</p>
          ))
        ) : (
          <p>Loading passage...</p>
        )}
      </div>

      <p className="text-gray-700 mb-4 text-center">
        <b>Summarize the points made in the lecture, being sure to explain how they oppose specific points made in the reading passage.</b>
      </p>
      <p className="text-gray-700 mb-4 text-center">
        Your response should be at least {minWords} words. Typically, an effective response is between 150-225 words.
      </p>

      <textarea
        value={essay}
        onChange={(e) => setEssay(e.target.value)}
        placeholder="Type your essay here..."
        rows={15}
        className="w-full p-4 border rounded-md mb-4"
      />

      <div className="text-center mb-4">
        <p className="text-lg text-gray-700">Time Remaining: <b>{formatTime(timeLeft)}</b></p>
        <p className="text-md text-gray-600">Word Count: {wordCount}</p>
      </div>

      {error && <p className="text-red-600 mb-4 text-center">{error}</p>}

      <div className="text-center">
        {!submitted ? (
          <button
            onClick={handleSubmit}
            className="mt-4 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-lg"
          >
            Submit Essay
          </button>
        ) : (
          <button
            onClick={() => navigate('/lessonMock/mock1/writing/2')}
            className="mt-4 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-lg"
          >
            Continue to Task 2
          </button>
          
        )}
        <h3>WARNING! The next task takes 10 minutes to complete. That includes reading AND writing!</h3>
      </div>
    </div>
  );
};

export default WritingTask1Write;
